import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import "../styles/home.css";

function TermsAndConditions() {
  return (
    <>
      <Header />

      {/* ======================================================
         FULL-WIDTH PAGE SHELL
         ====================================================== */}
      <main className="home-shell">
        <div className="home-container">

          {/* ======================================================
             TERMS & CONDITIONS
             ====================================================== */}
          <section className="section-block offset-left">
            <div className="section-card wide">

              <h2 className="section-title">terms and conditions</h2>

              <p>
                these terms and conditions (“terms”) govern your access to and use of
                the prufyy platform, including all associated websites, dashboards,
                applications, and services (collectively, the “services”). prufyy
                (“we”, “us”, or “our”) provides the services subject to your
                acceptance of and compliance with these terms.
              </p>

              <p>
                by accessing or using the services, you agree to be legally bound by
                these terms. if you do not agree, you must immediately discontinue
                all use of the services.
              </p>

              <h3>1. eligibility and authority</h3>
              <p>
                you represent and warrant that you are legally capable of entering
                into binding agreements and that you have the authority to act on
                behalf of any entity you represent. use of the services by minors is
                strictly prohibited.
              </p>

              <h3>2. description of services</h3>
              <p>
                prufyy provides a structured platform for presenting, organizing,
                sharing, and reviewing startup-related information, including but not
                limited to pitch materials, claims, evidence, evaluations, and
                records. prufyy does not provide investment advice, legal advice,
                financial advice, or guarantees of outcomes.
              </p>

              <h3>3. no guarantees or assurances</h3>
              <p>
                prufyy makes no representations, warranties, or guarantees regarding
                the accuracy, completeness, reliability, usefulness, or outcomes of
                any information presented on the platform. decisions made using the
                services are solely the responsibility of the user.
              </p>

              <h3>4. user content and responsibility</h3>
              <p>
                users retain ownership of content they submit to prufyy. however,
                users grant prufyy a non-exclusive, worldwide, royalty-free license
                to host, store, process, display, and transmit such content solely
                for the purpose of operating and improving the services.
              </p>

              <p>
                users are solely responsible for ensuring that their content is
                accurate, lawful, non-infringing, and appropriate. prufyy does not
                verify, endorse, or validate user-submitted content.
              </p>

              <h3>5. evaluator independence</h3>
              <p>
                evaluators, investors, incubators, accelerators, and other reviewers
                act independently. prufyy does not influence, control, or participate
                in evaluation decisions, opinions, or outcomes.
              </p>

              <h3>6. acceptable use</h3>
              <p>
                you agree not to misuse the services, including but not limited to:
              </p>
              <ul className="bullet-list">
                <li>uploading false, misleading, or unlawful information</li>
                <li>attempting to gain unauthorized access to the platform</li>
                <li>interfering with platform functionality or security</li>
                <li>using the services for competitive intelligence scraping</li>
              </ul>

              <h3>7. fees, subscriptions, and payments</h3>
              <p>
                certain features of prufyy may require payment of fees. all fees are
                disclosed at the time of purchase. you agree to pay all applicable
                charges associated with your selected plan.
              </p>

              <h3>8. no refunds policy</h3>
              <p>
                all payments made to prufyy are final and non-refundable. prufyy does
                not offer refunds, credits, or prorations for any reason, including
                but not limited to dissatisfaction, unused features, early
                termination, or perceived outcomes.
              </p>

              <h3>9. suspension and termination</h3>
              <p>
                prufyy reserves the right to suspend or terminate access to the
                services at its sole discretion, with or without notice, for any
                violation of these terms or for any reason deemed necessary to
                protect the platform or its users.
              </p>

              <h3>10. intellectual property</h3>
              <p>
                all platform software, design, trademarks, branding, and proprietary
                materials are owned by prufyy and protected by applicable laws.
                except as expressly permitted, no rights are granted to users.
              </p>

              <h3>11. limitation of liability</h3>
              <p>
                to the maximum extent permitted by law, prufyy shall not be liable
                for any indirect, incidental, consequential, special, or punitive
                damages arising out of or related to your use of the services,
                including decisions made based on platform information.
              </p>

              <h3>12. indemnification</h3>
              <p>
                you agree to indemnify, defend, and hold harmless prufyy from any
                claims, liabilities, damages, losses, or expenses arising from your
                use of the services, your content, or your violation of these terms.
              </p>

              <h3>13. governing law and jurisdiction</h3>
              <p>
                these terms shall be governed by and construed in accordance with
                applicable laws, without regard to conflict of law principles. any
                disputes shall be subject to the exclusive jurisdiction of the
                appropriate courts.
              </p>

              <h3>14. modifications to terms</h3>
              <p>
                prufyy reserves the right to modify these terms at any time. changes
                will be effective upon posting. continued use of the services
                constitutes acceptance of the revised terms.
              </p>

              <h3>15. contact information</h3>
              <p>
                for questions regarding these terms, contact:
              </p>
              <p>
                <strong>email:</strong>{" "}
                <a href="mailto:support@prufyy.com">support@prufyy.com</a>
              </p>

            </div>
          </section>

        </div>
      </main>

      <Footer />
    </>
  );
}

export default TermsAndConditions;
